<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout  align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-1 ">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Simjob</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <!-- <img
              src="logo.png"
              class="pa-2"
              style="display: block;margin-left: auto;margin-right: auto;width: 50%;"
            />-->

            <v-card-text>
              <div class="d-flex justify-center ">
                <v-img
                  :src="logo"
                  max-width="250"
                  max-height="250"
                ></v-img>
              </div>
              <alert-box v-model="alert.alerts" :type="alert.type" />
              <locale-select locale-default />

              <form v-on:submit.prevent="sendLogin()">
                <v-text-field
                  v-model="model.username"
                  prepend-icon="mdi-account-circle"
                  name="login"
                  :label="$t('username')"
                  type="text"
                  :disabled="loadingButton"
                  @keyup.enter.native="sendLogin"
                ></v-text-field>
                <v-text-field
                  v-model="model.password"
                  prepend-icon="mdi-lock"
                  name="password"
                  :label="$t('password')"
                  id="password"
                  type="password"
                  :disabled="loadingButton"
                  @keyup.enter.native="sendLogin"
                ></v-text-field>
              </form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :loading="loadingButton"
                @click="sendLogin"
                >{{ $t("login") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>

export default {
  data() {
    return {
      logo: require("../assets/simjob.png"),
      model: { username: "", password: "" },
      loadingButton: false,
      loading: true,
      alert: { alerts: [], type: "error" },
    };
  },
  methods: {
    async sendLogin() {
      this.loadingButton = true;
      let res = await this.$auth.login(
        this.model.username,
        this.model.password
      );
      this.loadingButton = false;
      if (!res.success) {
        this.alert.alerts = res.data;
        this.$forceUpdate();
        return;
      }
      
      this.$router.push({ name: "Home" });
      
    },
  
    async isAuthenticated() {
      let userParams = await this.$auth.getUserParams();
      if (!userParams) return false;
      let isAuthenticated = await this.$auth.isAuthenticatedAPI();
      if (isAuthenticated) await this.$router.push({ name: "Home" });
      return isAuthenticated;
    },
  },

  async mounted() {
    if (this.$route.query.notification) {
      this.alert.alerts.push(this.$route.query.notification);
    }

    if (!this.$route.query.notification) await this.isAuthenticated();
  },
};
</script>